import { render } from "./CustomFlowsView.vue?vue&type=template&id=4fa9bd9a&scoped=true"
import script from "./CustomFlowsView.vue?vue&type=script&lang=js"
export * from "./CustomFlowsView.vue?vue&type=script&lang=js"

import "./CustomFlowsView.vue?vue&type=style&index=0&id=4fa9bd9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa9bd9a"]])

export default __exports__